















import { computed, defineComponent, PropType } from "@vue/composition-api";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { FileData } from "@scrile/api-provider/dist/api/FileProvider";
import { MessageAttachment } from "@scrile/api-provider/dist/api/MessagesProvider";
import { MediaFilesController } from "@/lib/MediaFilesController";
import saveFile from "@/lib/saveFileHelper";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "DocumentAttachmentPreview",
  components: { BaseButton, BaseIcon },
  props: {
    file: { type: Object as PropType<ContentFile | MessageAttachment | FileData>, required: true },
    accessed: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const filename = computed(() =>
      "file" in props.file
        ? props.file.file.metadata.filename
        : "fileId" in props.file
        ? props.file.metadata.filename
        : props.file.name
    );
    const downloadUrl = computed(() =>
      MediaFilesController.getFileUrl("file" in props.file ? props.file.file.urlPart : props.file.urlPart)
    );

    const onClick = () => {
      if (!props.accessed) return emit("click");
      saveFile({ href: downloadUrl.value, name: filename.value });
    };

    return { filename, onClick };
  },
});
